import { initBridge, type TypedWebBridge } from "@picklebet/messaging-bridge";

/**
 * Singleton bridge instance for the web app
 * Initialized lazily on first access
 */
let bridge: TypedWebBridge | null = null;

/**
 * Get the web bridge instance
 * Creates it on first call, returns cached instance thereafter
 */
export function getBridge(): TypedWebBridge {
  if (!bridge) {
    bridge = initBridge({
      origin: "web",
      debug: process.env.GATSBY_DEBUG_BRIDGE === "true",
      legacyMode: process.env.GATSBY_ENABLE_LEGACY_BRIDGE === "true",
    });
  }
  return bridge;
}
